import { Component } from 'react';

import { FormattedMessage } from 'react-intl';

import styles from './SingleLinkedProvider.module.css';
import SingleProviderAccount from './SingleProviderAccount';
import messages from '../LinkedAccounts.messages';
import { getLogoFromProvider } from '../LinkedAccountsHelpers';

// eslint-disable-next-line import/no-default-export
export default class SingleLinkedProvider extends Component {
    getProviderLogo = () => {
        const { accountServiceProviderId } = this.props;
        return getLogoFromProvider(accountServiceProviderId);
    };

    unlinkAccount = () => {
        const { providerId, bankName, unlinkLinkedAccount } = this.props;

        unlinkLinkedAccount(providerId, bankName);
    };

    render() {
        const { bankName, accounts, linkedAt, logo_url } = this.props;

        const ProviderLogo = this.getProviderLogo();

        return (
            <div
                className={styles.SingleLinkedProvider}
                data-testid="linkedAccountProvider"
            >
                <div
                    className={styles.header}
                    style={{
                        backgroundColor: ProviderLogo.backgroundColor,
                        color: ProviderLogo.textColor
                    }}
                >
                    <div
                        className={styles.bankLogo}
                        style={{
                            backgroundColor: ProviderLogo.backgroundColor,
                            borderColor: ProviderLogo.borderColor
                        }}
                    >
                        {logo_url ? (
                            <img
                                src={logo_url}
                                alt={bankName}
                                data-testid="bank-logo"
                            />
                        ) : (
                            <div className="legacy-open-banking-logo">
                                <ProviderLogo />
                            </div>
                        )}
                    </div>
                    <h2 className={styles.providerTitle}>{bankName}</h2>
                    <button
                        onClick={this.unlinkAccount}
                        className={styles.unlink}
                        style={{
                            color: ProviderLogo.textColor,
                            borderColor: ProviderLogo.borderColor
                        }}
                    >
                        <FormattedMessage {...messages.unlink} />
                    </button>
                </div>
                {accounts.map((account) => {
                    return (
                        <SingleProviderAccount
                            key={`provider-account-${account.providerId}-${linkedAt}`}
                            {...account}
                        />
                    );
                })}
            </div>
        );
    }
}
